const Resources = {

    table_headers: [
        { 
            name: '#',
        },
        { 
            name: 'Question',
        },
        { 
            name: 'Response',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Surveys',
            href:   '/qc-surveys',
            arrow:  "",
        },
    ],

}

export default Resources;